import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCRory extends NPC {
    constructor() {
        super(definitions.NPC_ID.RORY);

        this.collisionRadius = 20;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_rory_idle_00"));
        
        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(0, -6));
        this.animateIdle(0.4);
    }
}